import environmentConfig from './utils/configs';

const config = {
    EVENT_NAMESPACE: 'beststart-powerbi-embedded-web',
    env: import.meta.env.MODE,
    csharpBackendUrl: environmentConfig.csharpBackendUrl,
    LogLevel: environmentConfig.LogLevel || 0,
    authentication: {
        clientId: environmentConfig.clientId,
        authority: environmentConfig.authority,
        domainHint: environmentConfig.domainHint,
        loginHint: environmentConfig.loginHint,
        preferredLoginDomains: environmentConfig.preferredLoginDomains || [],
    },
};

export default config;
